import React from "react";
import { Link } from "react-router-dom";

export default class FooterOne extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <footer className="footer-one-sec">
          <div
            className="footer-one__pattern"
            style={{
              backgroundImage:
                "url(" +
                publicUrl +
                "assets/images/pattern/footer-v1-pattern.png)",
            }}
          ></div>
          <div className="footer-one__top">
            <div
              className="footer-one__top-img"
              style={{
                backgroundImage:
                  "url(" +
                  publicUrl +
                  "assets/images/resources/retro_icon.png)",
              }}
            ></div>
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="footer-one__top-inner">
                    <div className="row">
                      <div
                        className="col-xl-4 col-lg-6 col-md-6 wow animated fadeInUp"
                        data-wow-delay="0.1s"
                      >
                        <div className="footer-widget__column footer-widget__about">
                          <div className="footer-widget__about-logo">
                            <Link to="/">
                              <img
                                src={
                                  publicUrl +
                                  "assets/images/resources/logo-1.png"
                                }
                                alt="Logo"
                              />
                            </Link>
                          </div>

                          <p className="footer-widget__about-text">
                            With decades of experience, Stonehenge Masonry &
                            Construction brings expertise and artistry to every
                            project, transforming your vision into reality.
                          </p>

                          <div className="footer-widget__about-social-link">
                            <ul>
                              <li>
                                <a href="https://www.instagram.com/stonehengemasonry.pro/" target="_blank" rel="noreferrer">
                                  <span className="first fab fa-instagram"></span>
                                  <span className="fab fa-instagram"></span>
                                </a>
                              </li>

                            </ul>
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp"
                        data-wow-delay="0.3s"
                      >
                        <div className="footer-widget__column footer-widget__services">
                          <h2 className="footer-widget__title">Our Services</h2>
                          <ul className="footer-widget__services-list">
                            <li className="footer-widget__services-list-item">
                              <Link to="/about">About Company</Link>
                            </li>
                            <li className="footer-widget__services-list-item">
                              <Link to="/services">Company Services</Link>
                            </li>
                            <li className="footer-widget__services-list-item">
                              <Link to="/portfolio">Company Project</Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        className="col-xl-2 col-lg-6 col-md-6 wow animated fadeInUp"
                        data-wow-delay="0.5s"
                      >
                        <div className="footer-widget__column footer-widget__explore">
                          <h2 className="footer-widget__title">Our Explore</h2>
                          <ul className="footer-widget__explore-list">
                            <li className="footer-widget__explore-list-item">
                              <Link to="/testimonials">Our Testinonials</Link>
                            </li>
                            <li className="footer-widget__explore-list-item">
                              <Link to="/contact">Contact</Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-one__bottom clearfix">
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="footer-one__bottom-inner">
                    <div className="footer-one__bottom-text">
                      <p>
                        Copyright &copy;2022. All rights reserved to{" "}
                        <Link to="/" style={{ color: "#00539C" }}>
                          Stonehenge
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}
